import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M11.9971 2.00598C6.47307 2.00598 1.99707 6.48598 1.99707 12.006C1.99707 17.53 6.47307 22.006 11.9971 22.006C17.5211 22.006 21.9971 17.53 21.9971 12.006C21.9971 6.48598 17.5171 2.00598 11.9971 2.00598V2.00598ZM3.99807 12.006C3.99807 10.159 4.62607 8.45498 5.68007 7.10098L16.9051 18.326C15.5481 19.379 13.8451 20.005 11.9971 20.005C7.57707 20.005 3.99807 16.426 3.99807 12.006V12.006ZM18.3141 16.911L7.09207 5.68898C8.44607 4.63598 10.1491 4.00998 11.9971 4.00998C16.4141 4.00998 19.9961 7.59198 19.9961 12.009C19.9961 13.856 19.3681 15.557 18.3141 16.911V16.911Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Block');

export default Icon;
